(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bhs-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    document.querySelectorAll('.bhs-nav--desktop details[open]').forEach((item) => {
      if (!item.contains(event.target)) item.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('.bhs-nav--desktop details[open]');
    if (open) { open.open = false; open.querySelector('summary').focus(); }
  });
  document.addEventListener('focusin', (event) => {
    document.querySelectorAll('.bhs-nav--desktop details[open]').forEach((item) => {
      if (!item.contains(event.target)) item.open = false;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
